export interface IReceiptTypeDetails {
    vatNoVatReceiptTypeId:number;
    isDisplayOn:boolean;
    isPolicyViolationOn:boolean;
    receiptType:string;
    setupName:string;
}

export class ReceiptTypeDetails implements IReceiptTypeDetails {
    vatNoVatReceiptTypeId:number;
    isDisplayOn:boolean;
    isPolicyViolationOn:boolean; 
    receiptType:string;
    setupName:string
    constructor(vatNoVatReceiptTypeId:number,
        isDisplayOn:boolean,
        isPolicyViolationOn:boolean,
        receiptType:string,
        setupName:string)
    {
       this.vatNoVatReceiptTypeId = vatNoVatReceiptTypeId;
       this.isDisplayOn = isDisplayOn;
       this.isPolicyViolationOn=isPolicyViolationOn;
       this.receiptType = receiptType;
       this.setupName = setupName;
    }
}

export interface IReqReceiptTypeDetails{
    lstReceiptTypeDetails : IReceiptTypeDetails[];
    userId:number;
}

export class ReqReceiptTypeDetails implements IReqReceiptTypeDetails{
    lstReceiptTypeDetails : IReceiptTypeDetails[];
    userId:number;
    isNameChanged:boolean;
    isPolicyChanged:boolean;
    isDisplayChanged:boolean;
}

export interface IReceiptNumberPreference 
{
    receiptNumberLabel:string;
    duplicateCheckerReceipt:boolean;
    receiptNumberSettings:number;
}

export class ReceiptNumberPreference implements IReceiptNumberPreference
{
    receiptNumberLabel:string;
    duplicateCheckerReceipt:boolean;
    receiptNumberSettings:number;
}

export class ISaveInvoiceDataRequest 
{
    orgId: number;
    billingUserId: number; 
    billingEmail : string;
}
export class SaveInvoiceDataRequest implements ISaveInvoiceDataRequest
{
    orgId: number;
    billingUserId: number;
    billingEmail: string;
}

export class IGetUserIdForInvoiceRequest {
    orgId: number;
}

export class GetUserIdForInvoiceRequest implements IGetUserIdForInvoiceRequest {
    orgId: number;
}

export class IGetUserIdForInvoiceResponse {
    billingUserId: number;
}

export class GetUserIdForInvoiceResponse implements IGetUserIdForInvoiceResponse {
    billingUserId: number;
}